import StudentClient from '@/api/StudentClient'

export default class StudentProfileModel {
  constructor(http) {
    this.initializing = true;
    this.client = new StudentClient(http);
  }

  async initialize(studentUserId) {
    this.studentUserId = studentUserId;

    try {
      const student = await this.client.getProfile(studentUserId);

      this.individualCreditsRemaining = student.individualCreditsRemaining;
      this.groupCreditsRemaining = student.groupCreditsRemaining;

      this.classYear = student.classYear;
      this.isFullTimeStudent = student.isFullTimeStudent;
      this.isInternationalStudent = student.isInternationalStudent;
      this.isStudentAthlete = student.isStudentAthlete;
      this.studentIdNumber = student.studentIdNumber;

      this.bio = student.bio;
      this.city = student.city;
      this.email = student.email;
      this.ethnicity = student.ethnicity;
      this.fullName = student.fullName;
      this.gender = student.gender;
      this.phoneNumber = student.phoneNumber;
      this.state = student.state;

      this.photoUrl = student.photoUrl;
      this.authReleaseFormUrl = student.authReleaseFormUrl;

      this.outcomes = student.outcomes || [];
      this.struggles = student.struggles || [];
    } finally {
      this.initializing = false;
    }
  }
}
